module.exports = __webpack_public_path__ + "static/media/blue_dot_icon.49d8709f.svg";